/* eslint-disable */
export default {
  tollFree: 'フリーダイヤル',
  rcvPmiMeetingTitle: '{extensionName}のビデオ会議',
} as const;

// @key: @#@"tollFree"@#@ @source: @#@"Toll-Free"@#@
// @key: @#@"rcvPmiMeetingTitle"@#@ @source: @#@"{extensionName}'s video meeting"@#@
